import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../Common/styles/Charts.css';
import Perfil from './Perfil/Perfil';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Services } from './Services/Services';
import Stratification from './Stratification/Stratification';
import Production from './Production/Production';
import { menus } from './Common/Consts/sidebar';
import { HomeNav } from '../Common/Home/HomeNav';

function DashBoardSiaSus() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />
            <div className="dashboards-page">
                <HomeNav menus={menus} />
                <Routes>
                    <Route
                        path="/"
                        element={<Navigate to="services" replace />}
                    />
                    <Route path="/services/*" element={<Services />} />

                    <Route path="/perfil/*" element={<Perfil />} />
                    <Route
                        path="/stratification/*"
                        element={<Stratification />}
                    />
                    <Route path="/production/*" element={<Production />} />
                </Routes>
            </div>
        </QueryClientProvider>
    );
}

export default DashBoardSiaSus;
